(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Only activate drag on desktop — mobile uses native touch */
  if (window.innerWidth < 769) return;

  function initDrag(wrap) {
    var isDown   = false;
    var startX   = 0;
    var scrollLeft = 0;
    var moved    = false;

    wrap.addEventListener('mousedown', function (e) {
      /* Ignore clicks on links/buttons */
      if (e.target.closest('a, button')) return;
      isDown     = true;
      moved      = false;
      startX     = e.pageX - wrap.offsetLeft;
      scrollLeft = wrap.scrollLeft;
      wrap.classList.add('is-dragging');
    });

    document.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      wrap.classList.remove('is-dragging');
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x    = e.pageX - wrap.offsetLeft;
      var walk = (x - startX) * 1.2;
      if (Math.abs(walk) > 4) moved = true;
      wrap.scrollLeft = scrollLeft - walk;
    });

    /* Prevent click after drag */
    wrap.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  function init() {
    document.querySelectorAll('[data-mm-cat-drag]').forEach(initDrag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-contact-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mm-contact__form').forEach(function (form) {
      var loadedAtField = form.querySelector('.mm-contact__loaded-at');
      var loadedAt = Date.now();
      if (loadedAtField) loadedAtField.value = loadedAt;

      form.addEventListener('submit', function (e) {
        var hpInput = form.querySelector('input[name="contact[website]"]');
        var minElapsedMs = 3000; // submissions faster than this are almost certainly bots

        var isHoneypotFilled = hpInput && hpInput.value.trim() !== '';
        var isTooFast = Date.now() - loadedAt < minElapsedMs;

        if (isHoneypotFilled || isTooFast) {
          e.preventDefault();
          // Silently no-op instead of showing an error, so bots don't learn to adapt.
          // A real visitor who is just fast-tabbing would rarely hit both checks at once,
          // but if this ever misfires, they can simply click Send Message again.
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-product-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initGallery(root) {
    var gallery    = root.querySelector('[data-mm-gallery]');
    if (!gallery) return;

    var mainImg    = gallery.querySelector('[data-mm-main-img]');
    var mainVideo  = gallery.querySelector('[data-mm-main-video]');
    var mainVideoSource = mainVideo ? mainVideo.querySelector('[data-mm-main-video-source]') : null;
    var mainWrap   = gallery.querySelector('.mm-pdp__main-wrap');
    var thumbs     = gallery.querySelectorAll('[data-mm-thumb]');
    var dots       = root.querySelectorAll('[data-mm-dot]');
    var nextBtn    = gallery.querySelector('[data-mm-next]');
    var prevBtn    = gallery.querySelector('[data-mm-prev]');
    var zoomBtn    = gallery.querySelector('[data-mm-zoom-open]');
    var dialog     = root.parentElement ? root.parentElement.querySelector('[data-mm-zoom-dialog]') : document.querySelector('[data-mm-zoom-dialog]');
    var zoomImg    = dialog ? dialog.querySelector('[data-mm-zoom-img]') : null;
    var zoomClose  = dialog ? dialog.querySelector('[data-mm-zoom-close]') : null;
    var current    = 0;
    var videoLoadId = 0;
    var total      = thumbs.length;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var prefersReducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var swipeTarget = mainWrap || mainImg;

    function stopVideo() {
      if (!mainVideo) return;
      videoLoadId++;
      try { mainVideo.pause(); } catch (e) {}
      mainVideo.classList.add('mm-pdp__media-hidden');
    }

    function playVideo(posterSrc, videoSrc) {
      if (!mainVideo) return;

      var loadId = ++videoLoadId;
      var sourceChanged = mainVideoSource &&
        videoSrc &&
        mainVideoSource.getAttribute('src') !== videoSrc;

      if (posterSrc) mainVideo.poster = posterSrc;
      mainVideo.preload = 'auto';

      if (sourceChanged) {
        mainVideoSource.setAttribute('src', videoSrc);
      }

      function revealAndPlay() {
        if (loadId !== videoLoadId) return;

        mainImg.classList.add('mm-pdp__media-hidden');
        mainVideo.classList.remove('mm-pdp__media-hidden');

        if (zoomBtn) zoomBtn.classList.add('mm-pdp__media-hidden');

        if (!prefersReducedMotion) {
          var p = mainVideo.play();
          if (p && p.catch) p.catch(function () {});
        }
      }

      /* Keep the poster/image visible until enough video has buffered. */
      if (sourceChanged || mainVideo.readyState < HTMLMediaElement.HAVE_FUTURE_DATA) {
        mainVideo.addEventListener('canplay', revealAndPlay, { once: true });

        if (sourceChanged) {
          mainVideo.load();
        }
      } else {
        revealAndPlay();
      }
    }

    function goTo(idx) {
      if (total === 0) return;
      idx = (idx + total) % total;
      current = idx;

      var thumb     = thumbs[idx];
      var mediaType = thumb.getAttribute('data-media-type') || 'image';
      var src       = thumb.getAttribute('data-src');
      var zoom      = thumb.getAttribute('data-zoom');
      var alt       = thumb.querySelector('img') ? thumb.querySelector('img').alt : '';

      /* Active states (shared by both media types) */
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      dots.forEach(function (d) { d.classList.remove('is-active'); });
      if (dots[idx]) dots[idx].classList.add('is-active');

      if (mediaType === 'video') {
        var videoSrc = thumb.getAttribute('data-video-src');
        playVideo(src, videoSrc);
        return;
      }

      /* Image slide — make sure any playing video is stopped first */
      stopVideo();
      if (zoomBtn) zoomBtn.classList.remove('mm-pdp__media-hidden');

      mainImg.classList.remove('mm-pdp__media-hidden');
      mainImg.classList.add('is-loading');
      var newImg    = new Image();
      newImg.onload = function () {
        mainImg.src = src;
        mainImg.alt = alt;
        mainImg.classList.remove('is-loading');
        if (zoomImg) zoomImg.src = zoom;
      };
      newImg.src = src;
    }

    /* Thumbnail clicks */
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.getAttribute('data-mm-thumb'), 10));
      });
    });

    /* Prev / Next arrows */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goTo(current - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goTo(current + 1); });
    }

    /* Swipe / drag support — bound to the wrap so it works for image or video slides */
    if (swipeTarget) {
      swipeTarget.addEventListener('touchstart', function (e) {
        swipeStartX = e.touches[0].clientX;
        swipeStartY = e.touches[0].clientY;
      }, { passive: true });

      swipeTarget.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - swipeStartX;
        var dy = e.changedTouches[0].clientY - swipeStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          goTo(dx < 0 ? current + 1 : current - 1);
        }
      }, { passive: true });

      /* Mouse drag (desktop) */
      swipeTarget.addEventListener('mousedown', function (e) { swipeStartX = e.clientX; });
      swipeTarget.addEventListener('mouseup', function (e) {
        var dx = e.clientX - swipeStartX;
        if (Math.abs(dx) > 40) { goTo(dx < 0 ? current + 1 : current - 1); }
      });
    }

    /* Zoom open */
    if (zoomBtn && dialog) {
      zoomBtn.addEventListener('click', function () {
        var src = thumbs[current] ? thumbs[current].getAttribute('data-zoom') : mainImg.src;
        if (zoomImg) { zoomImg.src = src; zoomImg.alt = mainImg.alt; }
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      });
    }

    /* Zoom close */
    if (zoomClose && dialog) {
      zoomClose.addEventListener('click', function () {
        dialog.close();
        document.body.style.overflow = '';
      });
    }

    /* Close dialog on backdrop click */
    if (dialog) {
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) {
          dialog.close();
          document.body.style.overflow = '';
        }
      });
    }

    /* ── VARIANT SELECTOR ── */
    var variantData = root.querySelector('[data-mm-variants-json]');
    var variants    = [];
    try { variants = JSON.parse(variantData ? variantData.textContent : '[]'); } catch(e) {}

    var form        = document.getElementById('pf-form-' + root.getAttribute('data-product-id'));
    var hiddenId    = form ? form.querySelector('[data-mm-variant-id]') : null;
    var priceWrap   = root.querySelector('[data-mm-price]');
    var sticky      = root.querySelector('[data-mm-sticky]');

    /* Product-level state (from tags, rendered server-side) */
    var pfState        = root.getAttribute('data-pf-state') || 'normal';
    var comingSoonText = root.getAttribute('data-coming-soon-text') || 'COMING SOON';
    var preorderText   = root.getAttribute('data-preorder-text') || 'PRE-ORDER';
    var cartSvg =
      '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
      '<path d="M6 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM15 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z' +
      'M1.5 1.5H3l2 9.5h9L16 5H4.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

    /* Max purchasable qty for a variant: capped to stock only when tracked + not backorder */
    function maxForVariant(v) {
      if (!v) return null;
      if (v.inventory_management === 'shopify' && v.inventory_policy !== 'continue') {
        return typeof v.inventory_quantity === 'number' ? v.inventory_quantity : null;
      }
      return null; /* untracked or backorder allowed → no cap */
    }

    function applyQtyMax(variant) {
      if (!form) return;
      var qtyInput = form.querySelector('[data-mm-qty]');
      if (!qtyInput) return;
      var mx = maxForVariant(variant);
      if (mx === null) {
        qtyInput.removeAttribute('max');
      } else {
        qtyInput.setAttribute('max', mx);
        var val = parseInt(qtyInput.value, 10) || 1;
        if (mx >= 1 && val > mx) { qtyInput.value = mx; }
      }
    }

    function getSelectedOptions() {
      var sel = [];
      if (!form) return sel;
      /* Get all option groups in order */
      var optGroups = {};
      form.querySelectorAll('input[type="radio"][name^="options"]').forEach(function (r) {
        if (!optGroups[r.name]) optGroups[r.name] = null;
        if (r.checked) optGroups[r.name] = r.value;
      });
      Object.keys(optGroups).forEach(function (k) {
        if (optGroups[k]) sel.push(optGroups[k]);
      });
      return sel;
    }

    function findVariant(selected) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
    }

    function updateSwatch(label, value) {
      /* Update the displayed color label */
      var colorLabel = root.querySelector('[data-mm-color-label]');
      if (colorLabel) colorLabel.textContent = value;
    }

    function updatePrice(variant) {
      if (!priceWrap || !variant) return;

      /* Hide price entirely when sold out — except Coming Soon, where price stays visible */
      if (pfState !== 'coming-soon' && variant.available !== true) {
        priceWrap.classList.add('mm-pf__price-wrap--hidden');
        return;
      }
      priceWrap.classList.remove('mm-pf__price-wrap--hidden');

      var money = function(cents) {
        var num = parseFloat(cents);
        if (isNaN(num)) return '—';
        return (num / 100).toLocaleString('en-EG', { minimumFractionDigits: 0 });
      };
      var currency = 'EGP';
      var priceRow = priceWrap.querySelector('.mm-pf__price-row');
      if (!priceRow) return;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        priceRow.innerHTML =
          '<span class="mm-pf__price mm-pf__price--sale">' + currency + ' ' + money(variant.price) + '</span>' +
          '<s class="mm-pf__compare">' + currency + ' ' + money(variant.compare_at_price) + '</s>' +
          '<span class="mm-pf__save-pill">Save ' + pct + '%</span>';
      } else {
        priceRow.innerHTML = '<span class="mm-pf__price">' + currency + ' ' + money(variant.price) + '</span>';
      }
    }

    function updateATC(variant) {
      var atcBtn = form ? form.querySelector('.mm-pf__atc-btn') : null;
      if (!atcBtn) return;

      /* Coming Soon — always disabled regardless of variant/stock */
      if (pfState === 'coming-soon') {
        atcBtn.disabled = true;
        atcBtn.type = 'button';
        atcBtn.removeAttribute('name');
        atcBtn.classList.add('mm-pf__atc-btn--disabled');
        atcBtn.classList.remove('mm-pf__atc-btn--preorder');
        atcBtn.textContent = comingSoonText;
        return;
      }

      var isAvail = variant && variant.available === true;

      if (!isAvail) {
        /* Sold out (also applies to pre-order once the arriving stock runs out) */
        atcBtn.disabled = true;
        atcBtn.type = 'button';
        atcBtn.removeAttribute('name');
        atcBtn.classList.add('mm-pf__atc-btn--disabled');
        atcBtn.classList.remove('mm-pf__atc-btn--preorder');
        atcBtn.textContent = 'SOLD OUT';
        return;
      }

      /* Available */
      atcBtn.disabled = false;
      atcBtn.type = 'submit';
      atcBtn.setAttribute('name', 'add');
      atcBtn.classList.remove('mm-pf__atc-btn--disabled');

      if (pfState === 'pre-order') {
        atcBtn.classList.add('mm-pf__atc-btn--preorder');
        atcBtn.innerHTML = cartSvg + preorderText;
      } else {
        atcBtn.classList.remove('mm-pf__atc-btn--preorder');
        atcBtn.innerHTML = cartSvg + 'ADD TO CART';
      }
      syncSticky();
    }

    /* Mirror the main buy button onto the sticky bar CTA (text + state) */
    function syncSticky() {
      if (!sticky || !form) return;
      var mainBtn   = form.querySelector('.mm-pf__atc-btn');
      var stickyCta = sticky.querySelector('[data-mm-sticky-cta]');
      if (!mainBtn || !stickyCta) return;
      stickyCta.textContent = mainBtn.textContent.trim();
      stickyCta.disabled = mainBtn.disabled;
      stickyCta.classList.toggle('mm-pf__atc-btn--disabled', mainBtn.classList.contains('mm-pf__atc-btn--disabled'));
      stickyCta.classList.toggle('mm-pf__atc-btn--preorder', mainBtn.classList.contains('mm-pf__atc-btn--preorder'));
    }

    /* Keep the sticky qty number in sync with the real quantity input */
    function syncStickyQty() {
      if (!sticky || !form) return;
      var mainQty = form.querySelector('[data-mm-qty]');
      var disp    = sticky.querySelector('[data-mm-sticky-qty-display]');
      if (mainQty && disp) disp.textContent = mainQty.value;
    }

    function updateAvailability(selected) {
      /* Mark each option value as available/unavailable based on current selections */
      if (!form || !variants.length) return;
      var allLabels = form.querySelectorAll('[data-option-value]');
      allLabels.forEach(function (lbl) {
        var val   = lbl.getAttribute('data-option-value');
        var input = lbl.querySelector('input[type="radio"]');
        if (!input) return;
        /* Check if any variant with this option value is available */
        var isAvail = variants.some(function (v) {
          return v.available === true && v.options.indexOf(val) > -1;
        });
        lbl.classList.toggle('is-unavailable', !isAvail);
        if (input) input.setAttribute('data-unavailable', isAvail ? '' : 'true');
      });
    }

    function onVariantChange() {
      var selected = getSelectedOptions();
      if (!selected.length) return;

      /* Update active swatch UI */
      var lastChanged = document.activeElement;
      if (lastChanged && lastChanged.name && lastChanged.name.startsWith('options')) {
        updateSwatch(lastChanged.name, lastChanged.value);
      }

      /* Update availability styling */
      updateAvailability(selected);

      var match = findVariant(selected);
      if (!match) return;

      /* Update hidden form id */
      if (hiddenId) hiddenId.value = match.id;

      /* Update wishlist variant */
      var wlBtn = root.querySelector('.mm-pf__wl-circle');
      if (wlBtn) wlBtn.setAttribute('data-variant-id', match.id);

      /* Update URL without reload */
      var newUrl = window.location.pathname + '?variant=' + match.id;
      history.replaceState({ variantId: match.id }, '', newUrl);

      /* Update price */
      updatePrice(match);

      /* Update ATC button */
      updateATC(match);

      /* Cap quantity to the selected variant's stock */
      applyQtyMax(match);

      /* Update gallery image */
      if (match.featured_image) {
        var imgId = String(match.featured_image.id);
        thumbs.forEach(function (t, i) {
          if (t.getAttribute('data-image-id') === imgId) { goTo(i); }
        });
      }
    }

    /* Listen on all option radios — form is the source of truth */
    if (form) {
      form.addEventListener('change', function (e) {
        if (!e.target.matches('input[type="radio"][name^="options"]')) return;

        /* Update active pill/swatch UI */
        var radioName = e.target.name;
        form.querySelectorAll('input[name="' + radioName + '"]').forEach(function (r) {
          var lbl = form.querySelector('label[for="' + r.id + '"]');
          if (lbl) lbl.classList.toggle('is-active', r.checked);
        });

        /* Update displayed option value label */
        var optIdx = e.target.getAttribute('data-mm-opt-index');
        if (optIdx) {
          var valLabel = root.querySelector('[data-mm-opt-val="' + optIdx + '"]');
          if (valLabel) valLabel.textContent = e.target.value;
        }

        onVariantChange();
      });
    }

    /* Shopify native variant:changed (if fired by Horizon) */
    document.addEventListener('variant:changed', function (e) {
      if (!e.detail || !e.detail.variant) return;
      var v = e.detail.variant;
      updatePrice(v);
      updateATC(v);
      if (v.featured_image) {
        thumbs.forEach(function (t, i) {
          if (t.getAttribute('data-image-id') === String(v.featured_image.id)) { goTo(i); }
        });
      }
    });

    /* ── STICKY ADD-TO-CART BAR ── */
    if (sticky && form) {
      var mainQty  = form.querySelector('[data-mm-qty]');
      var mainBtn  = form.querySelector('.mm-pf__atc-btn');
      var sMinus   = sticky.querySelector('[data-mm-sticky-minus]');
      var sPlus    = sticky.querySelector('[data-mm-sticky-plus]');
      var sCta     = sticky.querySelector('[data-mm-sticky-cta]');

      /* Sticky qty stepper drives the real quantity input (respects stock cap) */
      function stickyStep(dir) {
        if (!mainQty) return;
        var cur  = parseInt(mainQty.value, 10) || 1;
        var maxA = mainQty.getAttribute('max');
        var maxV = (maxA === null || maxA === '') ? Infinity : (parseInt(maxA, 10) || Infinity);
        mainQty.value = Math.max(1, Math.min(dir < 0 ? cur - 1 : cur + 1, maxV));
        mainQty.dispatchEvent(new Event('change', { bubbles: true }));
        syncStickyQty();
      }
      if (sMinus) sMinus.addEventListener('click', function () { stickyStep(-1); });
      if (sPlus)  sPlus.addEventListener('click', function () { stickyStep(1); });
      if (mainQty) mainQty.addEventListener('change', syncStickyQty);

      /* Sticky CTA triggers the real (native) submit button */
      if (sCta) {
        sCta.addEventListener('click', function () {
          var real = form.querySelector('.mm-pf__atc-btn');
          if (real && !real.disabled && real.type === 'submit') { real.click(); }
        });
      }

      /* Show the bar only once the main buy button scrolls out of view */
      if (mainBtn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var show = !en.isIntersecting;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          });
        }, { threshold: 0 });
        io.observe(mainBtn);
      }

      /* Initial mirror */
      syncSticky();
      syncStickyQty();
    }
  }

  /* Read the max attr as a number, or Infinity when uncapped */
  function qtyMaxOf(inp) {
    var m = inp.getAttribute('max');
    if (m === null || m === '') return Infinity;
    var n = parseInt(m, 10);
    return isNaN(n) ? Infinity : n;
  }

  /* Quantity stepper — clamped between 1 and available stock */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-mm-minus]');
    var plus  = e.target.closest('[data-mm-plus]');
    if (!minus && !plus) return;
    var ctrl  = (minus || plus).closest('.mm-pf__qty-ctrl');
    if (!ctrl) return;
    var inp   = ctrl.querySelector('[data-mm-qty]');
    if (!inp) return;
    var cur   = parseInt(inp.value, 10) || 1;
    var maxV  = qtyMaxOf(inp);
    var next  = minus ? cur - 1 : cur + 1;
    next = Math.max(1, Math.min(next, maxV));
    inp.value = next;
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Clamp manual typing so a customer can never exceed stock */
  document.addEventListener('change', function (e) {
    var inp = e.target && e.target.matches && e.target.matches('[data-mm-qty]') ? e.target : null;
    if (!inp) return;
    var maxV = qtyMaxOf(inp);
    var val  = parseInt(inp.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    if (val > maxV) val = maxV;
    inp.value = val;
  });

  /* Init */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-id]').forEach(initGallery);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var CURRENCY = 'EGP';

  function money(cents) {
    return CURRENCY + ' ' + (cents / 100).toLocaleString('en-EG', { minimumFractionDigits: 0 });
  }

  /* ── Slider — no arrows, static 4-card grid ── */
  function initSlider(section) {
    var track = section.querySelector('[data-mm-rec-track]');
    var clip  = section.querySelector('.mm-rec__track-clip');
    if (!track || !clip) return;

    function setCardWidths() {
      var GAP     = 16;

      /* On mobile the layout is a CSS-driven swipeable carousel.
         Clear any inline widths so nothing overflows the screen. */
      if (window.innerWidth < 750) {
        Array.from(track.children).forEach(function (card) {
          card.style.flex     = '';
          card.style.width    = '';
          card.style.minWidth = '';
          card.style.maxWidth = '';
        });
        return;
      }

      var visible = window.innerWidth < 990 ? 3 : 4;
      var clipW   = clip.offsetWidth;
      var cardW   = Math.floor((clipW - GAP * (visible - 1)) / visible);
      Array.from(track.children).forEach(function (card) {
        card.style.flex     = '0 0 ' + cardW + 'px';
        card.style.width    = cardW + 'px';
        card.style.minWidth = cardW + 'px';
        card.style.maxWidth = cardW + 'px';
      });
    }

    setCardWidths();
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setCardWidths, 150);
    });
  }

  /* ── Bundle — Recommendations API + savings from compare_at_price ── */
  function initBundle(section) {
    var bundle    = section.querySelector('[data-mm-bundle]');
    var atcBtn    = section.querySelector('[data-mm-bundle-atc]');
    var slots     = section.querySelector('[data-mm-bundle-slots]');
    var pricesEl  = section.querySelector('[data-mm-bundle-prices]');
    var saveEl    = section.querySelector('[data-mm-bundle-save]');
    if (!atcBtn || !slots || !bundle) return;

    var productId      = atcBtn.getAttribute('data-product-id');
    var currentVid     = atcBtn.getAttribute('data-current-variant');
    var currentPrice   = parseInt(atcBtn.getAttribute('data-current-price'), 10) || 0;
    var currentCompare = parseInt(atcBtn.getAttribute('data-current-compare'), 10) || 0;
    var bundleVariants = [currentVid];

    /* Totals accumulate as products load.
       Only count compare-at as real when it's actually higher than the
       selling price — a compare-at of 0 (or equal to price) must fall back
       to price, same guard as the server-rendered curated path uses. */
    var totalPrice   = currentPrice;
    var totalCompare = currentCompare > currentPrice ? currentCompare : currentPrice;

    /* Price formatter — Shopify prices in cents */
    function fmt(cents) { return CURRENCY + ' ' + (cents / 100).toLocaleString('en-EG', { minimumFractionDigits: 2 }); }

    /* Build one bundle item HTML */
    function itemHTML(img, name, price, comparePrice, variantId, isCurrent) {
      var priceStr    = fmt(price);
      var isSale      = comparePrice > price;
      var priceClass  = isSale ? 'mm-rec__bundle-item-price mm-rec__bundle-item-price--sale' : 'mm-rec__bundle-item-price';
      var checkHTML   = isCurrent
        ? '<span class="mm-rec__bundle-check" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="6.5" fill="#B7332E" stroke="#B7332E"/><path d="M4 7L6 9L10 5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'
        : '';
      var varAttr     = variantId ? ' data-bundle-variant="' + variantId + '"' : '';
      var curClass    = isCurrent ? ' mm-rec__bundle-item--current' : '';
      return (
        '<div class="mm-rec__bundle-item' + curClass + '"' + varAttr + '>' +
          checkHTML +
          '<div class="mm-rec__bundle-img-wrap">' + (img || '') + '</div>' +
          '<span class="mm-rec__bundle-item-name">' + name + '</span>' +
          '<span class="' + priceClass + '">' + priceStr + '</span>' +
        '</div>'
      );
    }

    /* Update totals display — fallback mode only.
       With a curated bundle the total/savings are already rendered server-side.
       Always render both the before and after total together — the struck-through
       original must appear any time there's a real saving, same as the
       server-rendered curated path, not just the final price on its own. */
    function updateTotals() {
      if (!pricesEl) return;
      if ((atcBtn.getAttribute('data-curated-variants') || '').trim()) return;
      var savings = totalCompare - totalPrice;
      if (savings > 0) {
        pricesEl.innerHTML =
          '<s class="mm-rec__bundle-original">' + fmt(totalCompare) + '</s>' +
          '<span class="mm-rec__bundle-final">' + fmt(totalPrice) + '</span>';
        if (saveEl) {
          saveEl.classList.remove('mm-rec__bundle-save--hidden');
          saveEl.textContent = 'Bundle saves you ' + fmt(savings) + '!';
        }
      } else {
        pricesEl.innerHTML = '<span class="mm-rec__bundle-final">' + fmt(totalPrice) + '</span>';
        if (saveEl) saveEl.classList.add('mm-rec__bundle-save--hidden');
      }
    }

    updateTotals();

    /* ── CURATED BUNDLE (from the custom.complete_the_look metafield) ──
       When the merchant has picked the bundle, everything is already rendered
       server-side (items, prices, total, savings). We only wire the variant IDs
       for "Add all to cart" and skip the recommendations fetch entirely, so the
       bundle is stable and never changes between visits. */
    var curated = (atcBtn.getAttribute('data-curated-variants') || '').trim();
    if (curated) {
      bundleVariants = [currentVid].concat(
        curated.split(',').map(function (s) { return s.trim(); }).filter(Boolean)
      );
      return; /* server-rendered — no fetch, no re-render */
    }

    /* ── FALLBACK — no curated bundle: show related recommendations (previous behaviour) ── */

    /* Show skeletons while loading */
    slots.innerHTML =
      '<span class="mm-rec__bundle-sep" aria-hidden="true">+</span>' +
      '<div class="mm-rec__bundle-item"><div class="mm-rec__bundle-img-wrap mm-rec__bundle-skeleton-dot"></div><span class="mm-rec__bundle-item-name">Loading...</span><span class="mm-rec__bundle-item-price">—</span></div>' +
      '<span class="mm-rec__bundle-sep" aria-hidden="true">+</span>' +
      '<div class="mm-rec__bundle-item"><div class="mm-rec__bundle-img-wrap mm-rec__bundle-skeleton-dot"></div><span class="mm-rec__bundle-item-name">Loading...</span><span class="mm-rec__bundle-item-price">—</span></div>';

    /* Fetch related products */
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=3&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var recs = (data.products || []).slice(0, 3);
        slots.innerHTML = '';
        bundleVariants  = [currentVid];
        totalPrice      = currentPrice;
        totalCompare    = currentCompare > currentPrice ? currentCompare : currentPrice;

        recs.forEach(function (p) {
          var variant     = p.variants && p.variants[0];
          if (!variant) return;
          var price       = variant.price || 0;
          var compareRaw  = variant.compare_at_price || 0;
          var compare     = compareRaw > price ? compareRaw : price;
          totalPrice     += price;
          totalCompare   += compare;
          bundleVariants.push(String(variant.id));

          var img = p.featured_image
            ? '<img src="' + p.featured_image + '" alt="' + (p.title || '').replace(/"/g, '') + '" width="80" height="80" loading="lazy">'
            : '';

          slots.innerHTML +=
            '<span class="mm-rec__bundle-sep" aria-hidden="true">+</span>' +
            itemHTML(img, p.title || '', price, compare, String(variant.id), false);
        });

        updateTotals();
      })
      .catch(function () {
        slots.innerHTML = '';
        updateTotals();
      });

    /* ── Refresh + open the Horizon cart drawer with no lag ──
       Horizon listens for a native 'cart:update' event and re-renders the
       drawer + header count itself (confirmed on Horizon 3.x). We fire that
       synchronously on a successful add so there is no extra round-trip.
       The '@theme/events' module path is a best-effort fallback for other
       Horizon versions and is swallowed if the module is not present
       (e.g. Horizon 2.1.0 throws "Cannot find module '@theme/events'"). */
    function refreshHorizonCart(itemCount) {
      /* Primary: native Horizon event — updates count + refreshes the drawer */
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { itemCount: itemCount, source: 'product-form-component' } }
      }));

      /* Fallback for versions exposing the internal events module */
      try {
        import('@theme/events')
          .then(function (m) {
            if (!m || !m.CartUpdateEvent) return;
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.dispatchEvent(new m.CartUpdateEvent(cart, 'mm-bundle', {
                  itemCount: cart.item_count, source: 'mm-bundle', sections: {}
                }));
              })
              .catch(function () {});
          })
          .catch(function () { /* module not available on this theme version */ });
      } catch (e) { /* dynamic import unsupported — ignore */ }

      /* Open the drawer as a fallback if the theme did not auto-open it */
      var drawer = document.querySelector('cart-drawer-component')
                || document.querySelector('cart-drawer');
      if (drawer) {
        if (typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
        else { drawer.open = true; }
      }
    }

    /* Add All to Cart */
    atcBtn.addEventListener('click', function () {
      if (!bundleVariants.length || atcBtn.disabled) return;   /* guard double-submit */
      atcBtn.disabled    = true;
      atcBtn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: bundleVariants.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
      })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (e) { throw e; }); }
        return r.json();
      })
      .then(function () {
        /* Refresh the cart UI immediately — before restoring the label */
        refreshHorizonCart(bundleVariants.length);
        atcBtn.textContent = '✓ Added!';
        setTimeout(function () { atcBtn.disabled = false; atcBtn.textContent = 'ADD ALL TO CART'; }, 2000);
      })
      .catch(function (err) {
        atcBtn.disabled    = false;
        atcBtn.textContent = (err && err.description) ? err.description : 'Try again';
        setTimeout(function () { atcBtn.textContent = 'ADD ALL TO CART'; }, 2500);
      });
    });
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-id]').forEach(function (section) {
      if (section.querySelector('[data-mm-rec-track]')) {
        initSlider(section);
        initBundle(section);
      }
    });
  });

})();

  } catch(e) { console.error(e); }
})();
})();
